import { render, staticRenderFns } from "./OfertaDetailComponent.vue?vue&type=template&id=e8e6827c&scoped=true"
import script from "./OfertaDetailComponent.vue?vue&type=script&lang=js"
export * from "./OfertaDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./OfertaDetailComponent.vue?vue&type=style&index=0&id=e8e6827c&prod&scoped=true&lang=css"
import style1 from "./OfertaDetailComponent.vue?vue&type=style&index=1&id=e8e6827c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e6827c",
  null
  
)

export default component.exports